import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	HostListener,
	Input,
	Output,
} from "@angular/core";

@Component({
	selector: "ui-text-button",
	templateUrl: "./button.component.html",
	styleUrls: ["./button.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class TextButtonComponent {
	@Input() icon: string;
	@Input() loading: boolean;
	@Input() help: string;

	@Output() action = new EventEmitter<void>();

	@HostBinding("attr.tabIndex") tabIndex = 0;
	@HostBinding("class.disabled") @Input() disabled = false;
	@HostBinding("class.align-right") @Input() reverse = false;

	get iconClass() {
		if (this.loading) {
			return "fa fa-spin fa-refresh";
		}

		return this.icon;
	}

	@HostListener("click")
	onClick() {
		if (this.disabled) {
			return;
		}
		this.action.emit();
	}

	@HostListener("keydown.enter")
	onEnter() {
		if (this.disabled) {
			return;
		}
		this.action.emit();
	}
}
